import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  AlertMessage, AlertContainer, StatusIconContainer, CloseIconContainer,
} from './toast-message.style';
import successIcon from '../../../../assets/icon-success.svg';
import closeIcon from '../../../../assets/icon-dismissal-x.svg';
import errorIcon from '../../../../assets/icon-failure.svg';
import { clearAlert } from '../../../../store/alerts/slice';
import ALERT_TYPES from '../../../../store/alerts/constants';
import ImageIcon from '../image-icon';

/**
 * Toast Component for showing alerts
 * @return {element} - The Toast component
 */
const Toast = () => {
  // Redux hooks
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alert);

  // State hooks
  const [mousedOver, setMousedOver] = useState(false);

  /**
   * Callback to dismiss the toast message
   * @return {void}
   */
  const dismissAlert = useCallback(() => {
    dispatch(clearAlert());
  }, [dispatch]);

  /**
   * Sets an interval to dismiss alert message after 5 seconds.
   * If moused over, no interval is set.
   */
  useEffect(() => {
    let interval;
    if (!mousedOver && alert.message) {
      interval = setInterval(dismissAlert, 5000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [dismissAlert, mousedOver, alert]);

  // If there is no alert message, do not render anything
  if (!alert.message) {
    return null;
  }

  return (
    <AlertContainer
      onMouseEnter={() => setMousedOver(true)}
      onMouseLeave={() => setMousedOver(false)}
      alertType={alert.type}
      data-testid="toast-message"
    >
      <StatusIconContainer>
        <ImageIcon
          src={alert.type === ALERT_TYPES.success ? successIcon : errorIcon}
          altString={alert.type === ALERT_TYPES.success ? 'success' : 'error'}
          height={24}
          width={24}
        />
      </StatusIconContainer>
      <AlertMessage>{alert.message}</AlertMessage>
      <CloseIconContainer>
        <ImageIcon
          src={closeIcon}
          altString="close icon"
          height={15}
          width={15}
          onClick={dismissAlert}
        />
      </CloseIconContainer>
    </AlertContainer>
  );
};

export default Toast;
